<template>
  <span>
    <span v-for="(c, index) of text" :key="index" :style="`animation-delay: ${index * delay}${unit}; transition-delay: ${index * delay}${unit}; ${customCss(index, text.length)}`" >{{ c }}</span>
  </span>
</template>

<script setup>

defineProps({
  text: {
    type: String,
    required: true
  },
  delay: {
    type: Number,
    required: false,
    default: 0.1
  },
  unit: {
    type: String,
    required: false,
    default: 's'
  },
  customCss: {
    type: Function,
    required: false,
    default: () => { return ""; }
  }
});

</script>

<style scoped>
span > span {
  min-width: 1ch;
}
</style>